import { IAddressRepository } from '../ports/repositories/IAddressRepository';
import { Address } from '../../entities/model/Address';

export class GetHouseAddressUseCase {
  constructor(private addressRepository: IAddressRepository) {}

  execute(): Address {
    return this.addressRepository.getHouseAddress();
  }
}

export class SaveHouseAddressUseCase {
  constructor(private addressRepository: IAddressRepository) {}

  execute(address: Address): void {
    this.addressRepository.saveHouseAddress(address);
  }
}

export class CheckInvoiceAddressUseCase {
  constructor(private repository: IAddressRepository) {}

  execute(): boolean {
    const address = this.repository.getInvoiceAddress();
    return address.street !== '';
  }
}
